import React from "react";
import { makeIconDef } from "./makeIconDef";
export var ExternalLinkIconDef = {
    'external-link': makeIconDef('external-link', {
        regular: function () { return React.createElement(React.Fragment, null,
            React.createElement("path", { d: "M10.1213 5H4V20H19V14.375", stroke: "currentColor" }),
            React.createElement("path", { d: "M13 3H21V11", stroke: "currentColor" }),
            React.createElement("path", { d: "M9 15L21 3", stroke: "currentColor" })); },
        filled: function () { return React.createElement(React.Fragment, null,
            React.createElement("path", { d: "M10.1213 5H4V20H19V14.375", stroke: "currentColor", strokeWidth: "2" }),
            React.createElement("path", { d: "M13 3H21V11", stroke: "currentColor", strokeWidth: "2" }),
            React.createElement("path", { d: "M9 15L21 3", stroke: "currentColor", strokeWidth: "2" })); },
    })
};
